import React, { useEffect, useState } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  makeStyles,
  Box,
  StepConnector,
  Typography,
  Button,
  Grid,
} from '@material-ui/core';
import { FiberManualRecord } from '@material-ui/icons';
import CheckIcon from '@material-ui/icons/Check';
import { AddCircleOutline } from '@material-ui/icons';
import BatchUnitDetails from './BatchUnitDetails';
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import Order from './Order';
// import Collection from './Collection';
// import Manufacturing from './Manufacturing';
// import Infusion from './Infusion';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    // width: '100%',
    // backgroundColor: '#EDEDED',
    '& .MuiStepLabel-label': {
      color: 'rgba(0, 0, 0, 0.87)',
      fontWeight: 500,
    },
  },
  stepper: {
    // backgroundColor: '#EDEDED',
    color: 'black',
  },
  circleIcon: {
    border: '2px solid #707070',
    color: '#FFFFFF',
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
  },
  activeCircleIcon: {
    border: '2px solid #1391C9',
    color: '#1391C9',
    fontWeight: 600,
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
  },
  checkedIcon: {
    border: '2px solid #1391C9',
    color: '#FFFFFF',
    fontWeight: 600,
    borderRadius: '50%',
    backgroundColor: '#1391C9',
    height: '2rem',
    width: '2rem',
  },
  completed: {
    border: '2px solid #1391C9',
    color: '#FFFFFF',
    fontWeight: 600,
    borderRadius: '50%',
    backgroundColor: '#1391C9',
    height: '2rem',
    width: '2rem',
  },
  inProgress: {
    border: '2px solid #1391C9',
    color: '#1391C9',
    fontWeight: 600,
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
    height: '2rem',
    width: '2rem',
  },
  active: {
    border: '2px solid #1391C9',
    fontWeight: 600,
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
    height: '2rem',
    width: '2rem',
    color: '#FFFFFF',
  },
  inActive: {
    border: '2px solid #707070',
    fontWeight: 600,
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
    color: '#FFFFFF',
    height: '2rem',
    width: '2rem',
  },
  // stepLebel: {
  //   fontWeight: 600,
  //   cursor: 'pointer',
  //   '&:hover': {
  //     color: 'red',
  //     cursor: 'pointer',
  //     textDecoration: 'uderline'
  //   },
  // },
  stepLabel1: {
    color: '#090a0b',
    fontWeight: 500,
    cursor: 'pointer',
    '&:hover': {
      color: '#1391C9',
      textDecoration: 'underline',
      cursor: 'pointer',
      textDecorationThickness: '3px',
      textDecorationOffset: '0.5em',
    },

    '&.MuiStepLabel-label': {
      color: 'blue !important',
    },
  },
  stepLabel2: {
    color: 'grey',
    '&.MuiStepLabel-label': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    cursor: 'pointer',
    '&:hover': {
      color: '#1391C9',
      textDecoration: 'underline',
      cursor: 'pointer',
      textDecorationThickness: '3px',
      textDecorationOffset: '0.5em',
    },
  },

  connectorIncomplete: {
    borderTop: '9px solid #707070',
  },
  connectorComplete: {
    borderTop: '9px solid #1391C9',
  },
  stepLabelActive: {
    color: '#1391C9',
    textDecoration: 'underline',
    cursor: 'pointer',
    textDecorationThickness: '3px',
    textDecorationOffset: '0.5em',
  },
  stepLabelInActive: {
    color: '#1391C9',
    textDecoration: 'underline',
    cursor: 'pointer',
    textDecorationThickness: '3px',
    textDecorationOffset: '0.5em',
    '&.MuiStepLabel-label': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  labelActive: {
    color: 'black',
    fontWeight: 500,
  },
  labelInActive: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontWeight: 500,
  },
  labelInProgress: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
  },
  labelCompleted: {
    color: '#1391C9',
    fontWeight: 500,
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  addButton: {
    border: '1px solid #ccc',
    textTransform: 'none',
    justifyContent: 'flex-start',
    fontSize: '0.875rem',
    width: '200px',
    borderRadius: '20px',
  },
  completeButton: {
    backgroundColor: '#f06543',
    color: '#fff',
    textTransform: 'none',
    fontSize: '0.875rem',
    width: '200px',
    borderRadius: '20px',
    '&:hover': {
      backgroundColor: '#d35430',
    },
  },
  stepperContainer: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
}));

// const stepperData = [
//   {
//   procedureNumberStart: 22,
//     procedureNumberEnd: 25,
//   scheduledStartTime: '2024-02-24T09:20:00',
//   scheduledEndTime:'2024-02-25T11:20:00',
//     actualStartTime: '2024-02-24T14:40:00',
//   actualEndTime:'',
//   unitOperationStatus: 'completed',
//   unitOperationID: 1,
//   unitOperationName: 'REACTION',
//   criticalProcessParameters:[
//     { parameter: 'Temperature', upperLimit: 185, lowerLimit: 175, value: 187, uom: 'C' },
//     { parameter: 'Volume', upperLimit: 2100, lowerLimit: 1950, value: 2000, uom: 'L' },
//     { parameter: 'Chemical 1 Concentration', upperLimit: 12, lowerLimit: 5, value: 10, uom: 'g/L' },
//   ]
//   },
//   {
//     procedureNumberStart: 20,
//       procedureNumberEnd: 30,
//       scheduledStartTime: '2024-02-24T09:20:00',
//       scheduledEndTime:'2024-02-25T11:20:00',
//         actualStartTime: '2024-02-24T14:40:00',
//       actualEndTime:'',
//     unitOperationStatus: 'inActive',
//     unitOperationID: 2,
//     unitOperationName: 'CENTRIFUGATION',
//     criticalProcessParameters:[
//       { parameter: 'Chemical 1 Concentration', upperLimit: 12, lowerLimit: 5, value: 10, uom: 'g/L' },
//     ]
//   },
//   {
//     procedureNumberStart: 22,
//       procedureNumberEnd: 25,
//       scheduledStartTime: '2024-02-24T09:20:00',
//       scheduledEndTime:'2024-02-25T11:20:00',
//         actualStartTime: '2024-02-24T14:40:00',
//       actualEndTime:'',
//     unitOperationStatus: 'inActive',
//     unitOperationID: 3,
//     unitOperationName: 'ROTARY VACUUM DRYER',
//     criticalProcessParameters:[
//       { parameter: 'Volume', upperLimit: 2100, lowerLimit: 1950, value: 2000, uom: 'L' },
//       { parameter: 'Chemical 1 Concentration', upperLimit: 12, lowerLimit: 5, value: 10, uom: 'g/L' },
//     ]
//   },
//   {
//     procedureNumberStart: 22,
//       procedureNumberEnd: 25,
//       scheduledStartTime: '2024-02-24T09:20:00',
//       scheduledEndTime:'2024-02-25T11:20:00',
//         actualStartTime: '2024-02-24T14:40:00',
//       actualEndTime:'',
//     unitOperationStatus: 'inActive',
//     unitOperationID: 4,
//     unitOperationName: 'POWDER FILLING',
//     criticalProcessParameters:[
//       { parameter: 'Temperature', upperLimit: 185, lowerLimit: 175, value: 187, uom: 'C' },
//     ]
//     }
// ]

const TableStepper = (props) => {
  const classes = useStyles();
  const { stepperData, sample, batchData, batchDetails} = props;
  const [activeStep, setActiveStep] = useState(sample ? stepperData[0].qcSamplingID: stepperData[0].unitOperationID);
  const [selected, setSelected] = useState(stepperData[0])
  // useEffect(() => {
  //   setActiveStep(stepperData ? stepperData[0].unitOperationID : {})
  //   setSelected(stepperData && stepperData[0])
  // },[stepperData])
  const handleStepClick = (step) => {
    setActiveStep(step);
    let selected
    if (sample) {
      selected = stepperData.filter((val)=> val.qcSamplingID === step)
    } else {
      selected = stepperData.filter((val)=> val.unitOperationID === step)
    }
    
    setSelected(selected ? selected[0]: {})
  };

  const InProgress = () => {
    return <FiberManualRecord className={classes.inProgress} />;
  };
  const Active = () => {
    return <FiberManualRecord className={classes.active} />;
  };
  const InActive = () => {
    return <FiberManualRecord className={classes.inActive} />;
  };
  const Completed = () => {
    return <CheckIcon className={classes.completed} />;
  };

  const handleStepIcon = (value) => {
    switch (String(value).toLowerCase()) {
      case 'active':
        return Active();
        break;
      case 'inactive':
        return InActive();
        break;
      case 'in progress':
        // return InProgress();
        return Active();
        break;
      case 'completed':
        return Completed();
        break;
      default:
        return null;
        break;
    }
  };

  const handleStepLabel = (value) => {
    switch (String(value).toLowerCase()) {
      case 'active':
        return classes.labelActive;
        break;
      case 'inactive':
        return classes.labelInActive;
        break;
      case 'in progress':
        return classes.labelInProgress;
        break;
      case 'completed':
        return classes.labelCompleted;
        break;
      default:
        break;
    }
  };

  const handleConnector = (value) => {
    switch (String(value).toLowerCase()) {
      case 'completed':
        return classes.connectorComplete;
        break;
      case 'active':
        return classes.connectorIncomplete;
        break;
      case 'inactive':
        return classes.connectorIncomplete;
        break;
      case 'in progress':
        return classes.connectorIncomplete;
        break;
      default:
        break;
    }
  };

  
    
  return (
    // <Box className={classes.root}>
      <Grid container>
        <Grid item xs={10} style={{marginBottom:'2rem'}}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        className={classes.stepper}
          >
            {stepperData && stepperData.map((val,i) => (
              <Step value='order' onClick={() => {
                if (sample) {
                  handleStepClick(val?.qcSamplingID)
                } else {
                  handleStepClick(val?.unitOperationID)
                }
                
              }}>
              <StepLabel
                className={
                  sample ? activeStep === val?.qcSamplingID ? classes.stepLabelActive : classes.stepLabel1 : activeStep === val.unitOperationID ? classes.stepLabelActive : classes.stepLabel1
                }
                  StepIconComponent={() => {
                    // if (sample) {
                    //   return handleStepIcon(val?.qcSamplingStatus)
                    // } else {
                    //   return handleStepIcon(val?.unitOperationStatus)
                    // }
                    return handleStepIcon('completed')
                  }}
                StepIconProps={{
                  active: sample ?  activeStep === val?.qcSamplingID : activeStep === val?.unitOperationID,
                  completed: activeStep > 0,
                  onClick: () => {
                    if (sample) {
                      handleStepClick(val?.qcSamplingID)
                    } else {
                      handleStepClick(val?.unitOperationID)
                    }
                  },
                }}
              >
                  <Typography className={sample ? handleStepLabel( val?.qcSamplingStatus): handleStepLabel(val.unitOperationStatus)}>{ sample ? val?.qcSamplingName : val?.unitOperationName}</Typography>
                </StepLabel>
                {i > 0 && <StepConnector
                  // classes={{ line: sample ? handleConnector(stepperData[i-1]?.qcSamplingStatus) : handleConnector(stepperData[i-1]?.unitOperationStatus) }}
                  classes={{ line: handleConnector('completed') }}
                style={{
                  top: '12px',
                  left: `calc(-50% + 17px)`,
                  right: `calc(50% + 17px)`,
                  position: 'absolute',
                  color: 'black',
                }}
              />}
                  
            </Step>
            ))}
          </Stepper>
        </Grid>
        <Grid item xs={2}>
      {/* <Box className={classes.buttonGroup}>
        <Button
          variant="outlined"
          className={classes.addButton}
            startIcon={<AddCircleOutline />}
            // disabled={selected &&
            //   (selected?.unitOperationStatus
            //     ? String(selected?.unitOperationStatus).toLowerCase() === 'completed'
            //     : selected?.qcSamplingStatus ?
            //       String(selected?.qcSamplingStatus).toLowerCase() === 'completed'
            //       : false)}
            disabled={true}
          // onClick={handleAddUnit}
        >
            {sample ? 'Add Step Sample':'Add Unit Operation'}
        </Button>
        <Button
          variant="contained"
          className={classes.completeButton}
            // onClick={handleNext}
            // disabled={selected &&
            //   (selected?.unitOperationStatus
            //     ? String(selected?.unitOperationStatus).toLowerCase() === 'completed'
            //     : selected?.qcSamplingStatus ?
            //       String(selected?.qcSamplingStatus).toLowerCase() === 'completed'
            //       : false)}
            disabled={true}
        >
          Mark as Complete
        </Button>
          </Box> */}
      </Grid>
      
      {stepperData && <BatchUnitDetails batchData={batchData} data={selected} sample={sample} batchDetails={batchDetails}  />}
        </Grid>
      
    // </Box>
  );
};

export default TableStepper;
